import zhCN from './lang/zh-CN';
import en from './lang/en-US';

export { zhCN, en };

export default {
  'zh-CN': zhCN,
  'en-US': en
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/locale/index.js